import CassetteLoader from '../CassetteLoader'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  text?: string
}

export function LoadingSpinner({ size = 'md', className = '', text }: LoadingSpinnerProps) {
  const sizeMap = {
    sm: 20,
    md: 40,
    lg: 80
  }

  return (
    <CassetteLoader 
      size={sizeMap[size]} 
      className={className}
      text={text}
      variant="overlay"
    />
  )
}
